import { createContext, useContext, useState, useEffect, useRef } from "react";
import { userServices } from "../APIServices/UserData/userServices";
import { plateformSettingServices } from "../APIServices/GlobalManagements/plateformSettingServices";

const AppContext = createContext();

export const AppProvider = ({ children }) => {
  let auth = localStorage.getItem("token");
  const [currentUserData, setCurrentUserData] = useState(null);
  const [plateformSettings, setPlateformSettings] = useState(null);
  const [organizationList, setOrganizationList] = useState([]);
  const [apiUpdator, setAPIUpdator] = useState("");
  const [openChat, setOpenChat] = useState(false);
  const [chatList, setChatList] = useState([]);

  const handleChatClick = (chatObj) => {
    setOpenChat(true);
    setChatList((prev) => {
      const index = prev.findIndex(
        (item) => item.inboxId === chatObj.inboxId
      );
      let updated = [...prev];
      if (index !== -1) {
        updated[index] = chatObj;
      } else {
        if (updated.length >= 3) {
          updated.shift();
        }
        updated.push(chatObj);
      }
      return updated;
    });
  };

  const handleRemoveChat = (chatObj) => {
    const { inboxId, sessionId } = chatObj;

    setChatList((prev) => {
      if (!prev.length) return prev;

      const updated = prev.filter(
        (item) =>
          !(
            item.inboxId === inboxId &&
            item.sessionId === sessionId
          )
      );

      setOpenChat(updated.length > 0);

      return updated;
    });
  };

  const getCurrectLoginUser = async () => {
    const data = await userServices.getCurrectLoginUser();
    setCurrentUserData(data?.data || null);
  };

  const getOrganizations = async () => {
    let data = await userServices.getOrganizations();
    setOrganizationList(data?.data || []);
  };

  const getSinglePlateformSettings = async () => {
    const data = await plateformSettingServices.getSinglePlateformSettings();
    setPlateformSettings(data?.data || null);
  };

  useEffect(() => {
    if (auth) {
      getSinglePlateformSettings();
      getCurrectLoginUser();
      getOrganizations();
    }
  }, []);

  return (
    <AppContext.Provider
      value={{
        // User
        currentUserData,
        setCurrentUserData,
        getCurrectLoginUser,

        // Platform / Theme
        plateformSettings,
        setPlateformSettings,
        getSinglePlateformSettings,

        //Organization
        getOrganizations,
        organizationList,

        // Vault
        setAPIUpdator,
        apiUpdator,

        //Inbox
        chatList,
        handleChatClick,
        handleRemoveChat,
        openChat
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export const useApp = () => useContext(AppContext);
